module.exports = __webpack_public_path__ + "img/prize1.189340f.png";